export function convertCentimeterToMeter (valueInCentimeters) {
  const valueinMeters = valueInCentimeters / 100;
  return valueinMeters;
};

export function centimetersToInches (centimeters) {
  const inches = centimeters / 2.54;
  return inches;
};
